import type { DiscoveredRouteModule } from '@/router/generator/types';

// Local constants
const AdminPaymentsView = () => import('@/views/admin/PaymentsView.vue');
const AdminPaymentsIndexView = () => import('@/views/admin/payments/IndexView.vue');
const AdminPaymentsFeaturesView = () => import('@/views/admin/payments/FeaturesView.vue');
const AdminPaymentsAccountView = () => import('@/views/admin/payments/AccountView.vue');
const AdminPaymentsDashboardView = () => import('@/views/admin/payments/DashboardView.vue');
const AdminPaymentsLayoutsView = () => import('@/views/admin/payments/LayoutsView.vue');
const AdminPaymentsOrdersView = () => import('@/views/admin/payments/OrdersView.vue');
const AdminPaymentsWebhooksView = () => import('@/views/admin/payments/WebhooksView.vue');
const AdminPaymentsKeysView = () => import('@/views/admin/payments/KeysView.vue');
const AdminPaymentsMarketplaceView = () => import('@/views/admin/payments/MarketplaceView.vue');
const AdminPaymentsAutomateView = () => import('@/views/admin/payments/AutomateView.vue');

export const NAME_ADMIN_PAYMENTS = 'AdminPayments';
export const NAME_ADMIN_PAYMENTS_INDEX = 'AdminPaymentsIndex';
export const NAME_ADMIN_PAYMENTS_FEATURES = 'AdminPaymentsFeatures';
export const NAME_ADMIN_PAYMENTS_ACCOUNT = 'AdminPaymentsAccount';
export const NAME_ADMIN_PAYMENTS_DASHBOARD = 'AdminPaymentsDashboard';
export const NAME_ADMIN_PAYMENTS_LAYOUTS = 'AdminPaymentsLayouts';
export const NAME_ADMIN_PAYMENTS_ORDERS = 'AdminPaymentsOrders';
export const NAME_ADMIN_PAYMENTS_WEBHOOKS = 'AdminPaymentsWebhooks';
export const NAME_ADMIN_PAYMENTS_KEYS = 'AdminPaymentsKeys';
export const NAME_ADMIN_PAYMENTS_MARKETPLACE = 'AdminPaymentsMarketplace';
export const NAME_ADMIN_PAYMENTS_AUTOMATE = 'AdminPaymentsAutomate';
export const PATH_ADMIN_PAYMENTS = 'payments';

const children = [
  { path: '', component: AdminPaymentsIndexView, name: NAME_ADMIN_PAYMENTS_INDEX, meta: { dataLoaders: ['project_document', 'features', 'payments_base', 'shopping_cart'] } },
  { path: 'features', component: AdminPaymentsFeaturesView, name: NAME_ADMIN_PAYMENTS_FEATURES, meta: { dataLoaders: ['project_document', 'features', 'payments_base'] } },
  { path: 'account', component: AdminPaymentsAccountView, name: NAME_ADMIN_PAYMENTS_ACCOUNT, meta: { dataLoaders: ['project_document', 'features', 'payments_base', 'project_secrets'] } },
  { path: 'dashboard', component: AdminPaymentsDashboardView, name: NAME_ADMIN_PAYMENTS_DASHBOARD, meta: { dataLoaders: ['project_document', 'features', 'payments_base', 'shopping_cart'] } },
  { path: 'layouts', component: AdminPaymentsLayoutsView, name: NAME_ADMIN_PAYMENTS_LAYOUTS, meta: { dataLoaders: ['project_document', 'features', 'payments_base'] } },
  { path: 'marketplace', component: AdminPaymentsMarketplaceView, name: NAME_ADMIN_PAYMENTS_MARKETPLACE, meta: { dataLoaders: ['project_document', 'payments_base', 'shopping_cart'] } },
  { path: 'orders', component: AdminPaymentsOrdersView, name: NAME_ADMIN_PAYMENTS_ORDERS, meta: { dataLoaders: ['project_document', 'payments_base', 'shopping_cart'] } },
  { path: 'keys', component: AdminPaymentsKeysView, name: NAME_ADMIN_PAYMENTS_KEYS, meta: { dataLoaders: ['project_document', 'project_secrets', 'admin_payment_data'] } },
  { path: 'webhooks', component: AdminPaymentsWebhooksView, name: NAME_ADMIN_PAYMENTS_WEBHOOKS, meta: { dataLoaders: ['project_document', 'project_secrets', 'admin_payment_data'] } },
  { path: 'automate', component: AdminPaymentsAutomateView, name: NAME_ADMIN_PAYMENTS_AUTOMATE, meta: { dataLoaders: ['project_document', 'project_secrets', 'admin_payment_data'] } },
];

export const route: DiscoveredRouteModule = {
  id: 'admin.payments',
  scope: 'admin',
  moduleKey: 'payments',
  name: NAME_ADMIN_PAYMENTS,
  path: PATH_ADMIN_PAYMENTS,
  component: AdminPaymentsView,
  redirect: { name: NAME_ADMIN_PAYMENTS_INDEX },
  meta: { requiresAdmin: true, dataLoaders: ['project_document', 'features', 'payments_base', 'shopping_cart'] },
  children,
};
